import { render, staticRenderFns } from "./DistrictUpsert.vue?vue&type=template&id=4e484a70&"
import script from "./DistrictUpsert.vue?vue&type=script&lang=js&"
export * from "./DistrictUpsert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports